import React from 'react';

export const ArrowForward = ({height = 14, width=8, stroke="var(--urtentic-sdk-primary, #255CFF)"}) => {

    return (
        <svg width={width} height={height} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1C1 1 6.99999 5.4189 7 7C7.00001 8.5812 1 13 1 13" stroke={stroke} strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
};